import React, { useEffect } from 'react'
import { motion } from 'framer-motion'

//Multimedia
import backgroudWeOffer from '../../Imgs/backgroudWeOffer.png'
import House from '../../Imgs/svg/House.svg'
import StarSucess from '../../Imgs/svg/StarSucess.svg'
import delivery from '../../Imgs/svg/weOffer/delivery.svg'
import money from '../../Imgs/svg/weOffer/money.svg'
import notes from '../../Imgs/svg/weOffer/notes.svg'
import graph from '../../Imgs/svg/weOffer/graph.svg'
import takeaway from '../../Imgs/svg/weOffer/takeaway.svg'
import deliverMan from '../../Imgs/svg/weOffer/deliverMan.svg'

function WeOffer() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  // clases tailwind Css
  const principalClassDiv =
    'grid grid-cols-1 md:grid-cols-2 items-start justify-center md:mb-[100px]'

  const h1Conoce =
    'tituloSecundario text-center md:text-left mb-[15px] md:mb-[30px]'

  const iconClass = 'h-[50px] md:h-[80px]  mb-[30px]'

  return (
    <div className=" flex justify-center p-[30px] ">
      <motion.div
        initial={{ x: -400 }}
        transition={{ duration: 1.2 }}
        animate={{ x: 0 }}
        className="container"
      >
        <div className={`${principalClassDiv}  items-center`}>
          <div className="flex flex-col">
            <h1 className="text-center md:text-left mb-[30px] md:mb-[60px]">
              <h1 className="tituloPrincipal">Lo que ofrecemos</h1>
            </h1>
            <p className="text-justify">
              <p className="textoGeneral">
                Pide y Pasa es una plataforma web y móvil para el sector retail
                de restaurantes. Ofrece opciones de pedir comidas de manera
                anticipada y pagar para después retirar el producto recién
                preparado en el restaurante.
                <br />
                <br />A través de nuestro sistema podrán mejorar los tiempos de
                entrega y la venta organizada de pedidos. Los clientes por medio
                de turnos puedan anticipadamente elegir los métodos de entregas
                para retirar en el mostrador (take out), Servicio en la mesa
                (Table Service) y retiro en el parqueadero (Drive in).
              </p>
            </p>
            <div className="flex">
              <a
                href="https://www.youtube.com/@PideYpasa/f"
                target="_blank"
                rel="noopener noreferrer"
              >
                {/* <h1 className="mt-[30px] md:mt-[60px] md:ml-[30px] text-lg text-center md:text-left md:text-1xl font-semibold mb-[30px] md:mb-[60px] underline">
                Ver video
              </h1> */}
              </a>
            </div>
          </div>

          <div className="flex justify-center  md:border-b-0">
            <img
              className="h-[150px] mb-[30px] md:mb-[0px]  mt-[30px] md:mt-[0px] md:h-[250px]"
              src={backgroudWeOffer}
              alt="delivery"
            />
          </div>
        </div>
        <div className={principalClassDiv}>
          <div className="h-full w-full hidden md:block">
            <div className="h-full flex justify-end  items-end">
              <img
                className="h-[250px] mr-[100px]"
                src={House}
                alt="delivery "
              />
            </div>
          </div>
          <div className="flex flex-col items-center md:items-start">
            <h1 className="tituloPrincipal text-center md:text-left  mb-[30px] md:mb-[60px] ">
              Gestiona tu restaurante
            </h1>
            <div className="flex  justify-center sm:block md:hidden">
              <img
                className="h-[150px] mb-[30px] mt-[30px]"
                src={House}
                alt="delivery"
              />
            </div>
            <p className="textoGeneral text-justify mb-[20px] lg:mr-[140px]">
              Publica los productos y ofertas según el tiempo de tus campañas
              promocionales e inventario. Atrae más clientes de manera fácil con
              cupones de digitales.
            </p>
            <div>
              <div className="flex items-center mt-[10px]">
                <img
                  className="h-[20px] mr-[10px]"
                  src={StarSucess}
                  alt="StarSucess"
                />
                <p className="textoGeneral text-base font-semibold">
                  Registra restaurante y sucursales
                </p>
              </div>
              <div className="flex items-center mt-[10px]">
                <img
                  className="h-[20px] mr-[10px]"
                  src={StarSucess}
                  alt="StarSucess"
                />
                <p className="textoGeneral text-base font-semibold">
                  Administra y controla tu inventario
                </p>
              </div>
              <div className="flex items-center mt-[10px]">
                <img
                  className="h-[20px] mr-[10px]"
                  src={StarSucess}
                  alt="StarSucess"
                />
                <p className="textoGeneral text-base font-semibold">
                  Productos y cupones digitales
                </p>
              </div>
              <div className="flex items-center mt-[10px]">
                <img
                  className="h-[20px] mr-[10px]"
                  src={StarSucess}
                  alt="StarSucess"
                />
                <p className="textoGeneral text-base font-semibold">
                  Códigos de descuento a clientes
                </p>
              </div>
              <div className="flex items-center mt-[10px]">
                <img
                  className="h-[20px] mr-[10px]"
                  src={StarSucess}
                  alt="StarSucess"
                />
                <p className="textoGeneral text-base font-semibold">
                  Informes de ventas
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className={principalClassDiv}>
          <h1 className="tituloPrincipal text-center md:text-left my-[70px] md:my-0">
            Conoce nuestra plataforma y conecta tu negocio
          </h1>
        </div>

        <div className={principalClassDiv}>
          <div className="flex flex-col md:items-start mb-[40px] md:mb-0 md:mr-[50px]">
            <img className={iconClass} src={delivery} alt="delivery" />
            <h1 className={h1Conoce}>Localización sucursales cercanas</h1>
            <p className="textoGeneral text-justify lg:mr-[100px]">
              Agrega las sucursales de tu restaurante con sus coordenadas para
              facilitarle la búsqueda, compra y entrega de los productos a tus
              clientes.
            </p>
          </div>
          <div className="flex flex-col md:items-start mb-[40px] md:mb-0 md:mr-[50px]">
            <img className={iconClass} src={money} alt="money" />
            <h1 className={h1Conoce}>Genera ganancias con Pide y Pasa</h1>
            <p className="textoGeneral text-justify lg:mr-[100px]">
              Somos plataforma de oportunidades para generar ingresos
              adicionales.
            </p>
          </div>
        </div>
        <div className={principalClassDiv}>
          <div className="flex flex-col md:items-start mb-[40px] md:mb-0 md:mr-[50px]">
            <img className={iconClass} src={notes} alt="notesPicture" />
            <h1 className={h1Conoce}>Pedidos en tiempo real</h1>
            <p className="textoGeneral text-justify lg:mr-[100px]">
              Nuestro sistema de Geolocalización en tiempo real te ayudará a
              organizar las órdenes en tiempos estimados de preparación.
            </p>
          </div>
          <div className="flex flex-col md:items-start mb-[40px] md:mb-0 md:mr-[50px]">
            <img className={iconClass} src={graph} alt="graph" />
            <h1 className={h1Conoce}>Ayudamos a crecer</h1>
            <p className="textoGeneral text-justify lg:mr-[100px]">
              Conoce cómo nuestro sistema Pide y Pasa para ayudan a empresarios
              y emprendedores a aumentar sus ventas con mayor rapidez.
            </p>
          </div>
        </div>
        <div className={principalClassDiv}>
          <div className="flex flex-col md:items-start mb-[40px] md:mb-0 md:mr-[50px]">
            <img className={iconClass} src={takeaway} alt="takeaway" />
            <h1 className={h1Conoce}>Somos eco-amigables</h1>
            <p className=" textoGeneral text-justify lg:mr-[100px]">
              Nos preocupamos por medio ambiente, por eso implementamos
              estrategias para disminuir el impacto de contaminación de papel.
            </p>
          </div>
          <div className="flex flex-col md:items-start mb-[40px] md:mb-0 md:mr-[50px]">
            <img className={iconClass} src={deliverMan} alt="deliverMan" />
            <h1 className={h1Conoce}>Entregas el mismo día</h1>
            <p className="textoGeneral text-justify lg:mr-[100px]">
              Una solución de entrega fácil que permite a las usuarios apartar
              sus productos el mismo día.
            </p>
          </div>
        </div>
      </motion.div>
    </div>
  )
}

export default WeOffer
